import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

import TooltipComponent from "../../../../ui/tooltip/TooltipComponent";

import "./DropdownSelect.scss";

function DropdownSelect(props) {
  return (
    <span className="d-inline-block custom-input">
      <Select
        value={props.value}
        key={props.keyId}
        className="custom-checkbox-select"
        onChange={props.handleDropdownChange}
        onBlur={props.handleDropdownBlur}
        options={props.optionsValue}
        isMulti={props.isMultiSelect}
        placeholder={props.placeholder}
        isDisabled={props.isDropdownDisabled}
        menuPortalTarget={document.body}
        menuPosition="absolute"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />

      {props?.inputInfoConfig?.isInfoIcon && (
        <TooltipComponent
          iconName={props.inputInfoConfig?.iconName}
          message={props.inputInfoConfig?.message}
        />
      )}
    </span>
  );
}
DropdownSelect.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.object),
  ]),
  keyId: PropTypes.string,
  handleDropdownChange: PropTypes.func.isRequired,
  handleDropdownBlur: PropTypes.func,
  optionsValue: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  inputInfoConfig: PropTypes.shape({
    isInfoIcon: PropTypes.bool,
    iconName: PropTypes.string,
    message: PropTypes.string,
  }),
  isMultiSelect: PropTypes.bool,
  placeholder: PropTypes.string,
  isDropdownDisabled: PropTypes.bool,
};

export default DropdownSelect;
